import { BirthCertificateForm, UpdateBrincoForm } from 'src/@types/validations/BirthCertificate'
import {
  BirthCertificateDto,
  CreateEarCertificateDto,
  EarringDto,
  EarTagBirthCertificateDto
} from 'src/dto/birth-certificate.dto'
import { BirthCertificateDtoParams, BirthCertificateService } from 'src/services/api/birth-certificate.service'

export class BirthCertificateController {
  private service: BirthCertificateService

  constructor() {
    this.service = new BirthCertificateService()
  }

  public async getBirthCertificateList(
    farmId: string,
    params?: BirthCertificateDtoParams
  ): Promise<BirthCertificateDto[]> {
    const response = await this.service.getBirthCertificateList(farmId, params)
    return response.data
  }

  public async getEarringTagBirthCertificateList(fichaId: string): Promise<BirthCertificateDto[]> {
    const response = await this.service.getEarringTagBirthCertificateList(fichaId)
    return response.data
  }

  public async getEarringList(earTagBirthCertificateId: string): Promise<EarTagBirthCertificateDto[]> {
    const response = await this.service.getEarringList(earTagBirthCertificateId)
    return response.data
  }

  public async updateBirthCertificate(
    farmId: string,
    birthCertificateDto: BirthCertificateForm
  ): Promise<BirthCertificateDto> {
    const response = await this.service.updateBirthCertificate(farmId, birthCertificateDto)
    return response.data
  }

  public async updateEarringCertificate(farmId: string, earCertificatePayload: CreateEarCertificateDto): Promise<any> {
    const response = await this.service.updateEarringCertificate(farmId, earCertificatePayload)
    return response.data
  }

  public async updateEarring(farmId: string, earringPayload: Omit<UpdateBrincoForm, 'tempId'>): Promise<EarringDto> {
    const response = await this.service.updateEarring(farmId, earringPayload)
    return response.data
  }
}
